module.exports = __webpack_public_path__ + "img/1560768670.75dc4bcf.jpg";